var sw = sw || {};


// Home fold slider 
//-----------------------------------------------------------------
zo.foldSlider = function() {

    var $slider = $('.js_foldSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        fade: true,
        speed: 1000,
        infinite: true,
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slide: '.fold__item',
        // appendDots: $('.fold__dots'),
        // appendArrows: $('.fold__arrows'),
        touchThreshold: 12,
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
    });

};






zo.foldGallery = function () {

    var $sliders = $('.js_foldGallery');

    if (!$sliders.length) {
        return;
    }

    function getSlidesToShow(total, wanted) {

        var whole = Math.floor(wanted);

        if (total > whole) {
            return wanted;
        }

        return total;
    }

    function getSliderOption($slider, name, fallback) {

        var value = parseFloat($slider.attr('data-' + name));

        if (isNaN(value)) {
            return fallback;
        }

        return value;
    }

    $sliders.each(function () {

        var $slider = $(this);
        var $gallery = $slider.closest('.gallery');
        var totalSlides = $slider.find('.gallery__item').length;

        var slidesDesktop = getSliderOption($slider, 'slides-desktop', 3.7);
        var slides1400 = getSliderOption($slider, 'slides-1600', 3.5);
        var slides1024 = getSliderOption($slider, 'slides-1024', 2.5);
        var slides480 = getSliderOption($slider, 'slides-480', 1.3);

        if (!totalSlides) {
            return;
        }

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }

        $slider
            .removeClass('loading')
            .addClass('is-ready');

        if (totalSlides === 1) {
            $slider.addClass('gallery__list--single');
            return;
        }

        $slider.slick({

            autoplay: false,
            arrows: true,
            dots: false,

            appendArrows: $gallery,

            prevArrow: '<button type="button" class="gallery__arrow gallery__arrow--prev" aria-label="Previous"><i class="icon-arrow-small-left"></i></button>',
            nextArrow: '<button type="button" class="gallery__arrow gallery__arrow--next" aria-label="Next"><i class="icon-arrow-small-right"></i></button>',

            slidesToShow: getSlidesToShow(totalSlides, slidesDesktop),
            slidesToScroll: 1,

            initialSlide: 0,
            speed: 400,
            waitForAnimate: false,

            infinite: false,
            centerMode: false,
            centerPadding: '0px',
            variableWidth: false,
            adaptiveHeight: false,

            touchThreshold: 12,

            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: getSlidesToShow(totalSlides, slides1400)
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: getSlidesToShow(totalSlides, slides1024)
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: getSlidesToShow(totalSlides, slides480)
                    }
                }
            ]

        });

        setTimeout(function () {
            $slider.slick('slickGoTo', 0, true);
            $slider.slick('setPosition');
        }, 100);

        $slider.find('img').on('load error', function () {
            if ($slider.hasClass('slick-initialized')) {
                $slider.slick('setPosition');
            }
        });

    });

    $(window).on('load resize orientationchange', function () {

        $('.js_foldGallery.slick-initialized').each(function () {
            $(this).slick('setPosition');
        });

    });

};





zo.foldPartners = function() {

    var $slider = $('.js_foldPartners').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: false,
        accessibility: false,
        infinite: true,
        centerMode: true,
        centerPadding: 0,
        touchThreshold: 12,
        slide: '.partners__item',
        appendDots: $('.partners__dots'),
        // appendArrows: $('.partners__arrows'),
        prevArrow: '<a class="partners__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="partners__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                 
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }     
            
        ]
    });
};

$(document).ready(function (){
    zo.foldSlider();
    zo.foldGallery();
    zo.foldPartners();
});